import { useLayoutStore } from '@/stores/layoutStore';

export function stopDocumentBodyFromScrollingWhenModalIsOpen() {
  const layoutStore = useLayoutStore();

  if (layoutStore.modalType) {
    document.body.classList.add('modal-open');
    return;
  }

  document.body.classList.remove('modal-open');
}
